import template from './template.html.twig';

Shopware.Component.override('sw-extension-card-base', {
    template,

    computed: {
        isPluginNetiNextOrderAmountHandler() {
            return this.extension?.name === 'NetiNextOrderAmountHandler';
        }
    }
});